import React, { useEffect } from "react";
import { Container, Row, Col, Card, Button, Badge } from "react-bootstrap";
import "./servicebio.css";
import { Carousel } from "react-bootstrap";
import Back from "../../../../components/backArrow";
import DescriptionIcon from "@mui/icons-material/Description";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CampaignIcon from "@mui/icons-material/Campaign";
import ReportIcon from "@mui/icons-material/Report";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import ShareModel from "../../../../components/Sharemodel";
import ShareOption from "../../../../components/Shareoption";
import { useState } from "react";
import RedoIcon from "@mui/icons-material/Redo";
import AddServiceModal from "../../../../components/Servicemodal_one";
import AddExperienceModal from "../../../../components/Service_Experience";
import AddCertificateeModal from "../../../../components/Service_Certificate";
import AboutServiceModal from "../../../../components/Service_About";
import { useNavigate } from "react-router-dom";
import CertificateModal from "../../../../components/Certificate_view_modal";
import PeopleRatingsModal from "../../../../components/Rating_People";
import AvailabilityModel from "../../../servicesProfile/components/Avalibilitymodel";
import { getAsset } from "../../../../helpers/helper";
import { useSelector } from "react-redux";
import GradeIcon from "@mui/icons-material/Grade";
import {
  useGetServiceDetailQuery,
  useLazyGetServicesByUserAndCategoryQuery,
} from "../../../../features/service/serviceApiSlice";
import { useGetShopRatingQuery } from "../../../../features/shop/shopApiSlice";
import noImagePlaceholder from "../../../../assets/images/dummy/no_image_placeholder.png";
import { encodeId } from "../../../../utils/idObfuscator";
import ShopStarRankLink from "../../../../components/ShopStarRank/ShopStarRankLink";

const Profile = ({ id }) => {
  const { name } = useSelector((state) => state.user);
  const [servicesdata, setServicesdata] = useState([]);
  const [aboutdata, setAboutdata] = useState("");
  const [experience, setExperience] = useState([]);
  const [certificate, setCertificate] = useState([]);
  const [showrating, setShowrating] = useState();

  const navigate = useNavigate();
  const [showshare, setShowshare] = useState(false);
  const [show, setShow] = useState(0);
  const [showModal, setShowModal] = useState(0);
  const [showcertificate, setShowcertificate] = useState(false);
  const [showpeoplerating, setShowpeoplerating] = useState(false);
  const handleClosepeople = () => setShowpeoplerating(false);
  const handleShowpeople = () => setShowpeoplerating(true);
  const [showavaliable, setShowavaliable] = useState(false);
  const handleCloseavai = () => setShowavaliable(false);
  const handleShow = () => setShowavaliable(true);
  const [shopData, setShopData] = useState("");
  const [certificateid, setCertificateid] = useState("");
  const handleModal = (e) => {
    setShowModal(e);
  };
  const handleCloseshare = () => {
    setShowshare(0);
    setShow(1);
  };
  const handleShowshare = () => {
    setShow(0);
    setShowshare(1);
  };

  const [getServices] = useLazyGetServicesByUserAndCategoryQuery();

  const Dataloaderfun = (shopData) => {
    if (shopData?.categoryid) {
      getServices({ userid: name?._id, categoryid: shopData.categoryid })
        .unwrap()
        .then((res) => {
          const service = res?.data?.Services?.[0];
          setServicesdata(service?.serviceArray || []);
          setAboutdata(service?.about || "");
          setExperience(service?.experienceArray || []);
          setCertificate(service?.certificateArray || []);
        })
        .catch((err) => console.error("Error fetching services:", err));
    }
  };

  const { data: shopRes } = useGetServiceDetailQuery(id, { skip: !id });

  useEffect(() => {
    if (shopRes?.success) {
      setShopData(shopRes?.data?.Service);
    }
  }, [shopRes]);

  useEffect(() => {
    if (shopData) {
      Dataloaderfun(shopData);
    }
  }, [shopData]);

  // Only the actual service owner should see owner-only controls
  const serviceOwnerId = shopData?.userid?._id || shopData?.userid || null;
  const loggedInUserId = name?._id || null;
  const isOwner =
    loggedInUserId &&
    serviceOwnerId &&
    String(loggedInUserId) === String(serviceOwnerId);

  const { data: ratingRes } = useGetShopRatingQuery(id, { skip: !id });

  useEffect(() => {
    if (ratingRes?.success) {
      setShowrating(ratingRes?.data?.averageRating);
    }
  }, [ratingRes]);

  return (
    <Container fluid>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <AddServiceModal
        show={showModal}
        id={id}
        handleClose={() => setShowModal(0)}
        Dataloaderfun={Dataloaderfun}
      />
      <CertificateModal
        id={id}
        show={showcertificate}
        setShowcertificate={setShowcertificate}
        certificateid={certificateid}
        Dataloaderfun={Dataloaderfun}
      />

      <AvailabilityModel
        handleCloseavai={handleCloseavai}
        showavaliable={showavaliable}
        setShowavaliable={setShowavaliable}
      />

      <PeopleRatingsModal
        show={showpeoplerating}
        handleClosepeople={handleClosepeople}
      />
      <AboutServiceModal
        id={id}
        show={showModal}
        handleClose={() => setShowModal(0)}
        shopData={shopData?.about}
        Dataloaderfun={Dataloaderfun}
      />

      <AddCertificateeModal
        id={id}
        Dataloaderfun={Dataloaderfun}
        show={showModal}
        handleClose={() => setShowModal(0)}
      />
      <AddExperienceModal
        show={showModal}
        id={id}
        Dataloaderfun={Dataloaderfun}
        handleClose={() => setShowModal(0)}
      />
      <ShareModel
        show={show}
        handleClosemodal={() => setShow(0)}
        handleShowshare={handleShowshare}
        shareurl={`/services-online/${encodeId(id)}`}
        shopTitle={shopData?.profileName}
        shopDesc={aboutdata || shopData?.about}
        shopImage={shopData?.images?.[0]}
      />
      {/* Go Back Button - Included as it's below navbar in screenshot */}
      <Row className="mb-3">
        <Col>
          <Button variant="link" className="go-back">
            <Back />
          </Button>
        </Col>
        <Col className="text-end">
          <button
            onClick={() => setShow(1)}
            className="text-white bg-blue  rounded mt-2 pt-1 pb-1 ps-4 pe-4"
            style={{
              backgroundColor: "#0353a4",
              border: "none",
              fontSize: "11px",
            }}
          >
            Share <RedoIcon className="share_icon_f" />
          </button>
        </Col>
      </Row>

      {/* Profile Header */}
      <Row className="profile-header align-items-start bg-white p-3 p-md-4 rounded">
        <Col xs={12} md={2} className="text-center">
          <img
            src={
              shopData?.images && shopData?.images?.length > 0
                ? getAsset(shopData?.images)
                : noImagePlaceholder
            }
            alt={shopData?.profileName || "Service profile"}
            className="profile-photo rounded-circle mb-3"
            crossOrigin="anonymous"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = noImagePlaceholder;
            }}
          />
        </Col>
        <Col xs={12} md={10}>
          <Row>
            <Col md={8} className="profile-details">
              <h4 className="profile-name mb-0">{shopData?.profileName}</h4>
              <ShopStarRankLink
                shop={shopData}
                shopId={id}
                enableServiceFallback
                businessType="services"
              />
              <p className="text-muted mb-0">
                Profile id {shopData?.serviceid}
              </p>
              <p className="text-muted mb-0">
                {[shopData?.country, shopData?.state, shopData?.city]
                  .filter(Boolean)
                  .join(", ")}
              </p>
              <p className="text-muted mb-0">{shopData?.address}</p>
              <div className="d-flex flex-wrap m-1 ms-0">
                <Badge pill className="me-2 mb-2 badge-silver">
                  {shopData?.subCategory}
                </Badge>
                {/* <Badge pill className="me-2 mb-2 badge-silver">UI/UX</Badge>
<Badge pill className="me-2 mb-2 badge-silver">Posters Designs</Badge>
<Badge pill className="me-2 mb-2 badge-silver">Branding</Badge> */}
              </div>
              <div className="d-flex align-items-center mb-2">
                {showrating !== undefined && showrating !== null ? (
                  <>
                    <p className="marginset d-flex mb-1">
                      <GradeIcon
                        fontSize="small"
                        style={{ marginTop: "1px" }}
                      />
                      <b>{showrating}</b>
                    </p>{" "}
                    &nbsp;&nbsp;
                    <button
                      className="text-white rounded pt-0 pb-0 ps-3 pe-3 border-0 font_11"
                      style={{ backgroundColor: "#0353a4" }}
                      onClick={handleShowpeople}
                    >
                      View Rating
                    </button>
                  </>
                ) : (
                  ""
                )}
              </div>
            </Col>
            <Col
              md={4}
              className="profile-actions text-end d-flex flex-column justify-content-start"
            >
              {isOwner && (
                <>
                  <Button
                    variant="primary"
                    className="mb-2"
                    onClick={() => navigate(`/update-service/${id}`)}
                  >
                    Update Profile
                  </Button>
                </>
              )}
              <Button variant="primary" className="mb-2" onClick={handleShow}>
                Set Availability
              </Button>
              <Button
                variant="primary"
                className="mb-2"
                onClick={() =>
                  navigate(`/add-consultancy-services-profile/${id}`)
                }
              >
                Add Consultancy Services
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  const bt = shopData?.businessType || "services";
                  const sid = shopData?._id || id;
                  if (bt) localStorage.setItem("BTtogetMarketer", bt);
                  if (sid) localStorage.setItem("shopid", String(sid));
                  navigate("/hire-marketers");
                }}
              >
                Hire us as marketer
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* Tabs */}
      <Row className="tabs-row bg-white p-3 rounded mt-3 justify-content-start">
        <Col xs="auto" className="tabs-item me-4">
          <span
            role="button"
            onClick={() => navigate(`/service-suggestion/${id}`)}
          >
            <EmojiObjectsIcon /> Suggestions
          </span>
        </Col>
        <Col xs="auto" className="tabs-item me-4">
          <span role="button" onClick={() => navigate(`/service-report/${id}`)}>
            <ReportIcon /> Reports
          </span>
        </Col>
        <Col xs="auto" className="tabs-item me-4">
          <span
            role="button"
            onClick={() => navigate(`/promote-service/${id}`)}
          >
            <CampaignIcon /> Promote Your Shop
          </span>
        </Col>
        <Col xs="auto" className="tabs-item">
          <span role="button">
            <LocationOnIcon /> Share location
          </span>
        </Col>
      </Row>

      {/* Services */}
      <Row className="mt-4">
        <Col lg="6" className=" text-left">
          <h5>Services</h5>
        </Col>
        <Col lg="6" className="text-end">
          <span
            role="button"
            className="text-primary"
            onClick={(e) => handleModal(1)}
          >
            <b>+ Add more</b>
          </span>
        </Col>
      </Row>
      <Row>
        {servicesdata.map((service, index) => (
          <Col xs={12} md={6} lg={6} key={index} className="p-3">
            <Row className="service-card h-100">
              <Col xs={12} lg={4} className="service-image-column pe-0">
                <Card.Img
                  variant="top"
                  src={
                    service?.images && service?.images?.length > 0
                      ? getAsset(service?.images)
                      : noImagePlaceholder
                  }
                  className="service-img"
                  alt={service.heading || "Service"}
                  crossOrigin="anonymous"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = noImagePlaceholder;
                  }}
                />
              </Col>

              <Col xs={12} lg={8} className="service-content-column ps-0">
                <Card.Body>
                  <Card.Title className="service-title">
                    {service.heading}
                  </Card.Title>
                  <Card.Text className="service-text font_14">
                    {(service.detail || "").length > 160
                      ? `${service.detail.substring(0, 160)}...read more`
                      : service.detail}
                  </Card.Text>
                  <div
                    className="service-link"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate(
                        `/view-service/${service?._id}/${id}?type=service`,
                      )
                    }
                  >
                    View/Edit details
                  </div>
                </Card.Body>
              </Col>
            </Row>
          </Col>
        ))}
      </Row>

      {/* About */}
      <Row className="mt-4">
        <Col lg="6" className=" text-left">
          <h5> About</h5>
        </Col>
        <Col lg="6" className="text-end">
          <span
            role="button"
            className="text-primary"
            onClick={(e) => handleModal(3)}
          >
            <b>Edit/Add</b>
          </span>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card className="about-card">
            <Card.Body>
              <Card.Text className="font_14">{aboutdata}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Experience */}
      <Row className="mt-4">
        <Col lg="6">
          <h5>Experience </h5>
        </Col>

        <Col lg="6" className="text-end">
          <span
            role="button"
            className="text-primary"
            onClick={(e) => handleModal(2)}
          >
            <b>+ Add more</b>
          </span>
        </Col>
      </Row>

      <Container className="my-4">
        <Row>
          {experience.map((service) => (
            <Col key={service.id} xs={12} sm={6} lg={4} className="mb-4">
              <Card className="custom-service-card shadow-sm h-100 border-0">
                <div className="custom-carousel-wrapper">
                  <Carousel interval={null} indicators={true}>
                    {(service.images?.length ? service.images : [null]).map(
                      (img, index) => (
                        <Carousel.Item key={index}>
                          <Card.Img
                            variant="top"
                            src={img ? getAsset(img) : noImagePlaceholder}
                            crossOrigin="anonymous"
                            alt={service.name || "Experience"}
                            className="custom-carousel-image"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = noImagePlaceholder;
                            }}
                          />
                        </Carousel.Item>
                      ),
                    )}
                  </Carousel>
                </div>
                <Card.Body>
                  <Card.Title className="fw-semibold">
                    {service.name}
                  </Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">
                    {service.projectName}
                  </Card.Subtitle>
                  <Card.Text className="text-muted small font_14">
                    {(service.detail || "").length > 160
                      ? `${service.detail.substring(0, 160)}...read more`
                      : service.detail}
                  </Card.Text>
                  <Button
                    variant="primary"
                    className="rounded-pill w-100 px-4 pt-1 pb-1  mt-2"
                    style={{ backgroundColor: "#0353a4", border: "none" }}
                    onClick={() =>
                      navigate(
                        `/view-service/${service?._id}/${id}?type=experience`,
                      )
                    }
                  >
                    View/Edit details
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Certifications */}
      <Row className="mt-4">
        <Col lg="6">
          <h5>Certifications </h5>
        </Col>

        <Col lg="6" className="text-end">
          <span
            role="button"
            className="text-primary"
            onClick={(e) => handleModal(4)}
          >
            <b>+ Add more</b>
          </span>
        </Col>
      </Row>

      <Row className="g-4">
        {certificate?.map((cert) => (
          <Col key={cert.id} xs={12} md={4}>
            <Card className="cert-card">
              <Card.Body className="d-flex align-items-start">
                <DescriptionIcon
                  fontSize="large"
                  className="cert-description-icon"
                  style={{ color: "#0353a4" }}
                />
                <div className="cert-content">
                  <Card.Title className="cert-title mb-1">
                    {cert.name}
                  </Card.Title>
                  <Card.Text className="cert-date mb-1">
                    Issue date: {cert.issueDate}
                  </Card.Text>
                  <div
                    className="cert-link"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setCertificateid(cert._id);
                      setShowcertificate(true);
                    }}
                  >
                    View/Edit Details
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Profile;
